import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import { Container, Col } from 'react-bootstrap';
import PropertiesPage from '../../../modules/property/PropertiesPage';

const Property = () => {
  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Property', link: '/property', active: true },
  ];

  return (
    <>
      <div className="bread-crumb">
        <Container>
          <Col md={8}>
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>

      <PropertiesPage routeBase="/property" />
    </>
  );
};

export default Property;
